import { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { reportApi } from '@formosa/shared/api/im';
import '../../styles/chat.css';

const REASONS = [
  { value: 'SPAM', label: '垃圾訊息' },
  { value: 'SCAM', label: '詐騙' },
  { value: 'HARASSMENT', label: '騷擾' },
  { value: 'SEXUAL_CONTENT', label: '色情內容' },
  { value: 'VIOLENCE', label: '暴力' },
  { value: 'IMPERSONATION', label: '冒充他人' },
  { value: 'ILLEGAL_CONTENT', label: '違法內容' },
  { value: 'OTHER', label: '其他' },
];

/** /chat/report?memberId=&conversationId=&serverMessageId= */
export default function ReportUserPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const memberId = params.get('memberId');
  const conversationId = params.get('conversationId') || undefined;
  const serverMessageId = params.get('serverMessageId') || undefined;

  const [reason, setReason] = useState('SPAM');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const backTo = useMemo(() => {
    if (conversationId) return `/chat/${conversationId}`;
    return '/chat/contacts';
  }, [conversationId]);

  const submit = async () => {
    if (!memberId) {
      setError('缺少被檢舉會員');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await reportApi.create({
        reportedMemberId: memberId,
        reason,
        description: description.trim() || undefined,
        conversationId: conversationId || undefined,
        serverMessageId: serverMessageId || undefined,
      });
      setDone(true);
    } catch (err) {
      setError(err?.message || '提交失敗');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="chat-social-page">
      <header className="chat-social-page__header">
        <Link to={backTo} className="chat-link-btn">
          ← 返回
        </Link>
        <h1>檢舉用戶</h1>
      </header>

      {!memberId ? (
        <p className="chat-social-page__error">缺少 memberId，請從聊天或聯絡人進入。</p>
      ) : done ? (
        <div>
          <p>已提交檢舉，我們會儘快審核。被檢舉者不會知道是誰檢舉。</p>
          <button type="button" className="group-create-form__submit" onClick={() => navigate(backTo)}>
            完成
          </button>
        </div>
      ) : (
        <div className="group-create-form">
          <p className="group-picker__hint">被檢舉會員 ID：{memberId}</p>
          {conversationId ? (
            <p className="group-picker__hint">關聯會話：{conversationId}</p>
          ) : null}

          <label className="group-create-form__field">
            <span>原因</span>
            <select
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{
                background: '#111',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 8,
                color: '#fff',
                padding: '10px 12px',
              }}
            >
              {REASONS.map((r) => (
                <option key={r.value} value={r.value}>
                  {r.label}
                </option>
              ))}
            </select>
          </label>

          <label className="group-create-form__field">
            <span>補充說明（選填）</span>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              maxLength={1000}
              rows={4}
              placeholder="請簡述情況，勿貼上無關個資"
              style={{
                background: '#111',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: 8,
                color: '#fff',
                padding: '10px 12px',
                resize: 'vertical',
              }}
            />
          </label>

          {error ? <p className="chat-social-page__error">{error}</p> : null}

          <button
            type="button"
            className="group-create-form__submit"
            disabled={submitting}
            onClick={submit}
          >
            {submitting ? '提交中…' : '提交檢舉'}
          </button>
        </div>
      )}
    </div>
  );
}
